
import { Base } from '../base-component';

import './supporting-content-card.component.scss';

export class SupportingContentCard extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/supporting-content-card/supporting-content-card.component.ts